import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { Activity } from 'shell-models-lib';


@Metamodel.model({})
export class ContainerActivityCase extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({})
    public value: string;

    @Metamodel.attribute({
        display: stringResources.Pipeline,
        type: Pipeline.MODEL
    })
    public casePipeline: Pipeline;

    constructor(value: string, casePipeline: Pipeline) {
        super();
        this.value = value;
        this.casePipeline = casePipeline;
    }

    public onActivityCloned(clonedActivity: ContainerActivityCase, context: { inlineDataset?: boolean }): void {
        if (this.casePipeline.activities != null) {
            this.casePipeline.activities.forEach((activity) => {
                const targetActivity = clonedActivity.casePipeline?.activities?.find((targetActivity) => targetActivity.name === activity.name);
                if (targetActivity != null && activity instanceof Activity) {
                    activity.onActivityCloned(targetActivity, context);
                }
            })
        }
    }
}
